import { Component, Input, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { SearchActionsService } from "../search-actions.service";
import {
    SearchHistoryItem,
    SearchHistoryService,
} from "../search-history.service";

@Component({
    selector: "app-search-history-item",
    templateUrl: "./search-history-item.component.html",
    styleUrls: ["./search-history-item.component.scss"],
})
export class SearchHistoryItemComponent implements OnInit {
    @Input() item: SearchHistoryItem;
    @Input() itemIndex: number;
    environment = environment;
    constructor(
        private searchActionsService: SearchActionsService,
        private searchHistoryService: SearchHistoryService
    ) {}

    ngOnInit(): void {}

    goToAccount(account) {
        this.searchActionsService.goToAccount(account);
    }
    createOrderWithCustomer(customer: any) {
        this.searchActionsService.createOrderWithCustomer(customer);
    }
    callAccount(customer: any) {
        this.searchActionsService.callAccount(customer);
    }
    startChat(customer: any) {
        this.searchActionsService.startChat(customer);
    }
    redirectToProductEdit(product: any) {
        this.searchActionsService.editProduct(product);
    }
    redirectToPublicView(product: any) {
        this.searchActionsService.redirectToProductPublicView(product);
    }
    goToOrder(orderLine: any) {
        this.searchActionsService.goToOrder(orderLine);
    }
    removeHistoryItem() {
        this.searchHistoryService.removeHistoryItem(this.itemIndex);
    }
}
